import MathUtils from '../../utils/MathUtils'
import Point from '../../geom/Point'
import Point3D from '../../geom/Point3D'
import Location from '../Location'
import DelaunayTriangulation from '../DelaunayTriangulation'
import BaseWithReferenceAreaProjection from './BaseWithReferenceAreaProjection'

function Triangulation(references) {
    this._referencesByLocation = [];
    this._referencesByPoint = [];

    var locations = [];
    var points = [];

    for (var i = 0; i < references.length; i++) {
        var reference = references[i];
        var location = new Point3D(reference.location.longitude, reference.location.latitude);
        this._referencesByLocation[location] = reference;
        locations.push(location);

        var point = new Point3D(reference.point.x, reference.point.y);
        this._referencesByPoint[point] = reference;
        points.push(point);
    }

    this._triangulationByLocations = new DelaunayTriangulation(locations);
    this._triangulationByPoints = new DelaunayTriangulation(points);
}

function locationFromPoint(point) {
    return new Location(point.y, point.x);
}

function pointFromLocation(location) {
    return new Point(location.longitude, location.latitude);
}

function ArtisticProjection(referenceAreas, referencePoints) {
    BaseWithReferenceAreaProjection.call(this, referenceAreas, referencePoints);
}

ArtisticProjection.prototype = new BaseWithReferenceAreaProjection();

ArtisticProjection.prototype.locationToPoint = function(location, skipArea = false) {
    var triangulation = new Triangulation(this.getProjectionReferencesForLocation(location, skipArea));
    var trigResult = triangulation.triangulateLocation(location);

    var ref1 = trigResult[0];
    var ref2 = trigResult[1];
    var ref3 = trigResult[2];

    var barycentricCoordinate = MathUtils.cartesianToBarycentric(pointFromLocation(ref1.location), pointFromLocation(ref2.location), pointFromLocation(ref3.location),
        pointFromLocation(location));

    var result = MathUtils.barycentricToCartesian(barycentricCoordinate, ref1.point, ref2.point, ref3.point);

    return result;
};

ArtisticProjection.prototype.pointToLocation = function(point, skipArea = false) {
    var triangulation = new Triangulation(this.getProjectionReferencesForPoint(point, skipArea));
    var trigResult = triangulation.triangulatePoint(point);

    var ref1 = trigResult[0];
    var ref2 = trigResult[1];
    var ref3 = trigResult[2];

    var barycentricCoordinate = MathUtils.cartesianToBarycentric(ref1.point, ref2.point, ref3.point, point);

    var latLong = MathUtils.barycentricToCartesian(barycentricCoordinate, pointFromLocation(ref1.location),
        pointFromLocation(ref2.location), pointFromLocation(ref3.location));
    var result = locationFromPoint(latLong);

    return result;
};

function completeTriangulation(trigResult) {
    var result = trigResult;
    if (trigResult.p1() == null) {
        result = trigResult.next_23();
    } else if (trigResult.p2() == null) {
        result = trigResult.next_31();
    } else if (trigResult.p3() == null) {
        result = trigResult.next_12();
    }
    return result;
}


Triangulation.prototype.triangulateLocation = function(location) {
    var trigResult = this._triangulationByLocations.find(new Point3D(location.longitude, location.latitude));
    trigResult = completeTriangulation(trigResult);

    var ref1 = this._referencesByLocation[trigResult.p1()];
    var ref2 = this._referencesByLocation[trigResult.p2()];
    var ref3 = this._referencesByLocation[trigResult.p3()];

    return [ref1, ref2, ref3];
};

Triangulation.prototype.triangulatePoint = function(point) {
    var trigResult = this._triangulationByPoints.find(new Point3D(point.x, point.y));
    trigResult = completeTriangulation(trigResult);
    var ref1 = this._referencesByPoint[trigResult.p1()];
    var ref2 = this._referencesByPoint[trigResult.p2()];
    var ref3 = this._referencesByPoint[trigResult.p3()];

    return [ref1, ref2, ref3];
};

export default ArtisticProjection;